<template>
  <span>{{ money }}</span>
</template>

<script>
import Vue from "vue";
import { formatM } from "@/lib/utils/accountingJsFns";

export default Vue.extend({
  name: "DeudaActualComponent",
  computed: {
    money() {
      return formatM(Number(this.params.data.deuda_actual));
    },
  },
});
</script>

<style scoped></style>
